import { Card, CircularProgress, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import DashboardLayout from "utils/LayoutContainers/DashboardLayout";
import DashboardNavbar from "utils/Navbars/DashboardNavbar";
import DataTable from "utils/Tables/DataTable";
import MDBadge from "components/MDBadge";
import { getAPICall } from "lib/callApi";
import { FETCH_USER_LIST } from "lib/constants";
import { enqueueSnackbar } from "notistack";
// import DeleteIcon from "@mui/icons-material/Delete";
// import Swal from "sweetalert2";

function Users() {
  const [users, setusers] = useState({
    columns: [
      { header: "Name", accessorKey: "name" },
      { header: "Company", accessorKey: "company", minWidth: "200px", width: "25%" },
      { header: "User type", accessorKey: "type" },
      {
        header: "Email",
        accessorKey: "email",
        wordBreak: "break-word",
        minWidth: "200px",
        width: "25%",
      },
      { header: "Status", accessorKey: "actions", width: "7%", disableSortBy: true },
    ],
    rows: [],
  });
  const [isLoading, setIsLoading] = useState(false);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const result = await getAPICall(FETCH_USER_LIST, true);
      if (result?.data?.success) {
        const dataFormat = [];
        result.data.data.forEach((data) => {
          dataFormat.push({
            name: data.name,
            company: data?.company,
            type: data.type,
            email: data.email,
            actions: (
              <MDBox sx={{ display: "flex" }}>
                <MDBox>
                  <MDBadge
                    variant="contained"
                    color={data.status.toLowerCase() === "active" ? "success" : "error"}
                    badgeContent={data.status}
                    container
                  />
                </MDBox>
                {/* <MDBox sx={{ margin: "5px" }}>
                <DeleteIcon
                style={{ cursor: "pointer" }}
                  onClick={() => callDeleteCompany(data.id)}
                />
              </MDBox> */}
              </MDBox>
            ),
          });
        });

        const duplicateSubscriptions = { ...users };
        duplicateSubscriptions.rows = dataFormat;
        setusers({ ...duplicateSubscriptions });
      } else if (result?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: result?.response?.data?.message || "Something Went Wrong",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: error?.response?.data?.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading ? (
        <Stack alignItems="center">
          <CircularProgress
            sx={{
              position: "fixed",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}
            color="info"
            size="10vh"
          />
        </Stack>
      ) : (
        ""
      )}
      <Card>
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight="medium">
            Users List
          </MDTypography>
        </MDBox>

        <MDBox>
          <DataTable table={users} />
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default Users;
